import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useInvoiceCard = (invoice) => {
  return useQuery({
    queryKey: ["invoiceCardState", invoice],
    queryFn: async () =>
      callApi({
        path: "invoiceCard",
        command: "",
        data: JSON.stringify({
          data: { filter: { noFilter: invoice } },
        }),
      }),
  });
};
